import { createFileRoute } from "@tanstack/react-router";
import { legacyReminderDispatchRoute } from "@/features/kits-conversations";

export const Route = createFileRoute("/api/internal/reminders/dispatch")({
    ...legacyReminderDispatchRoute,
});
